module.exports = __webpack_public_path__ + "static/media/logo_cyd.5737ba03.png";